import { observer } from 'mobx-react';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/filterNodata.png';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  BOMDefaultSortColumnOrder,
  BOMFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import IPageInfo, { IPageLimitInfo } from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import {
  CloseSidePanelIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import {
  getTenantIdFromLocalStorage,
  getUserId,
} from '../../helpers/localstorage-helper';
import Header from '../../shared-components/header/header';
import {
  bOMGroups,
  IBomGroup,
  IBOMSearchFilter,
} from '../../models/IBOMSearchFilter';
import { Button } from 'react-bootstrap';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import Filter from './components/filter';
import './bom-search.css';
import { useHistory, useLocation } from 'react-router-dom';
import { materialClassificationOptions } from '../../constants/options.constant';
const BOMSearch = (props: any) => {
  const { preferencesStore, bomStore, processStore, operatorStore } =
    useStore();

  const {
    GetBOMSearchResultsService,
    getBOMSearchResultsServiceState,
    resetGetBOMSearchResultsServiceState,
    allBOMSearchResults,
    BOMSearchResultsList,
    reset,
  } = bomStore;

  const {
    allProcessOptions,
    GetAllProcessService,
    getAllProcessState,
    nextProcessOptions,
  } = processStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  const {
    GetAssignedProcessListService,
    getAssignedProcessListState,
    allAssignedTasksNextProcessOptions,
  } = operatorStore;

  const history = useHistory();
  let lang: string;
  const allProcessListData = allBOMSearchResults;
  const isFirstLoad = useRef(true);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    BOMDefaultSortColumnOrder
  );

  const [filterObj, setFilterObj] = useState<IBOMSearchFilter>(
    BOMFilterInitialState
  );
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<IBomGroup[]>([]);
  const selectedIdsRef = useRef<any[]>([]);

  useEffect(() => {
    selectedIdsRef.current = selectedIds;
  }, [selectedIds]);

  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProcessListServiceHandler = (
    isSearchClicked: boolean,
    isPageChanged?: boolean,
    filterQuery?: IBOMSearchFilter
  ) => {
    setSelectedIds([]);
    setSelectedRow([]);
    setSelectedRowsData([]);
    if (isSearchClicked) {
      GetBOMSearchResultsService(
        Number(getTenantIdFromLocalStorage()),
        1,
        pageLimitInfo.pageLimit,
        filterQuery
      );
    } else if (isPageChanged) {
      GetBOMSearchResultsService(
        Number(getTenantIdFromLocalStorage()),
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        filterQuery
      );
    } else {
      GetBOMSearchResultsService(
        Number(getTenantIdFromLocalStorage()),
        1,
        pageLimitInfo.pageLimit,
        filterQuery
      );
    }
  };

  const location = useLocation() as any;

  useEffect(() => {
    if (location.state?.fromBack) {
      const parsedFilters =
        typeof location.state.filters === 'string'
          ? JSON.parse(location.state.filters)
          : location.state.filters;

      const updatedFilters = {
        ...parsedFilters,
        Column: 'MaterialProductId',
      };
      setFilterObj(updatedFilters);
      // setIsFilterApplied(true);
      setIsFilterCleared(false);
      getProcessListServiceHandler(false, false, updatedFilters);
    }
  }, [location.state]);

  useEffect(() => {
    reset();
    localStorage.removeItem('selectedRows');
    // GetAllProcessService(Number(getTenantIdFromLocalStorage()));
    GetAssignedProcessListService(
      Number(getUserId()),
      userSettingEnum.OperatorTaskOrder
    );
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: BOMSearchResultsList?.PagingDetails?.CurrentPage ?? 1,
      totalPages: BOMSearchResultsList?.PagingDetails?.TotalPages ?? 1,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [BOMSearchResultsList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProcessListServiceHandler(false, true, filterObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProcessListServiceHandler(false, true, filterObj);
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getProcessListServiceHandler(false, false);
    }
  }, [language]);

  useEffect(() => {
    if (getBOMSearchResultsServiceState.success) {
      setSelectedIds([]);
      setSelectedRow([]);
      setSelectedRowsData([]);
      resetGetBOMSearchResultsServiceState();
    }
  }, [getBOMSearchResultsServiceState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (
      selectedRow?.serialnumber &&
      row.serialnumber === selectedRow.serialnumber
    ) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setSelectedRow(row);
    if (
      selectedRow.serialnumber === undefined ||
      selectedRow.serialnumber !== row.serialnumber
    ) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getProcessListServiceHandler(false, false);
    closePanelHandler();
  };

  const filterHandler = (object: IBOMSearchFilter) => {
    const filters = {
      ...object,
      // SubContractor: object.SubContractorName === '' ? 0 : object.SubContractor,
      StartDate: object.StartDate ? object.StartDate : '2025-01-01',
      EndDate: object.EndDate
        ? object.EndDate
        : (() => {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 5);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
          })(),
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    //   const filter = createQueryString({ ...filters });
    setSelectedIds([]);
    setSelectedRowsData([]);
    localStorage.removeItem('selectedRows');
    getProcessListServiceHandler(true, false, filters);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: IBOMSearchFilter, isfilterCleard: boolean) => {
    //   const filter = createQueryString({
    //     ...obj,
    //     Column: columSortOrder.dataField,
    //     Order: columSortOrder.order,
    //   });

    if (isfilterCleard) {
      setSelectedIds([]);
      setSelectedRowsData([]);
      localStorage.removeItem('selectedRows');
      setFilterObj({ ...obj });
      reset();
      // getProcessListServiceHandler(filterObj, true);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));
  };

  // const selectRow = {
  //   mode: 'checkbox',
  //   clickToSelect: true,
  //   selected: selectedIds,
  //   onSelect: (row, isSelect) => {
  //     if (isSelect) {
  //       setSelectedIds((prev) => [...prev, row.serialnumber]);
  //     } else {
  //       setSelectedIds((prev) =>
  //         prev.filter(
  //           (serialnumber) => serialnumber !== row.serialnumber
  //         )
  //       );
  //     }
  //   },

  //   onSelectAll: (isSelect, rows) => {
  //     if (isSelect) {
  //       const allIds = rows.map((row) => row.serialnumber);
  //       setSelectedIds(allIds);
  //     } else {
  //       setSelectedIds([]);
  //     }
  //   },
  // };

  const mapRowToBOMGroup = (row: IBomGroup) => ({
    SubContractorName: row.SubContractorName || '',
    MaterialKatashiki: row.MaterialKatashiki || '',
    MaterialProductId: row.MaterialProductId || '',
    MaterialManufacturerName: row.MaterialManufacturerName || '',
  });

  const getSelectedBOMGroups = (): bOMGroups => {
    return allProcessListData
      .filter((row) => selectedIdsRef.current.includes(row.serialnumber))
      .map(mapRowToBOMGroup);
  };

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedIds,
    onSelect: (row, isSelect) => {
      const mappedRow = mapRowToBOMGroup(row);

      if (isSelect) {
        const next = selectedIdsRef.current.includes(row.serialnumber)
          ? selectedIdsRef.current
          : [...selectedIdsRef.current, row.serialnumber];
        selectedIdsRef.current = next;
        setSelectedIds(next);
        setSelectedRowsData((prev) => [...prev, mappedRow]);
      } else {
        const next = selectedIdsRef.current.filter(
          (serialnumber) => serialnumber !== row.serialnumber
        );
        selectedIdsRef.current = next;
        setSelectedIds(next);
        setSelectedRowsData((prev) =>
          prev.filter(
            (item) => item.MaterialProductId !== row.MaterialProductId
          )
        );
      }
    },

    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((row) => row.serialnumber);
        const allMapped = rows.map(mapRowToBOMGroup);
        selectedIdsRef.current = allIds;
        setSelectedIds(allIds);
        setSelectedRowsData(allMapped);
      } else {
        selectedIdsRef.current = [];
        setSelectedIds([]);
        setSelectedRowsData([]);
      }
    },
    selectionRenderer: ({ mode, checked, disabled }: any) => (
      <input
        type={mode}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        readOnly
      />
    ),
    selectionHeaderRenderer: ({ checked, indeterminate }: any) => (
      <input
        type="checkbox"
        checked={checked}
        ref={(input: HTMLInputElement | null) => {
          if (input) input.indeterminate = indeterminate;
        }}
        className="form-check-input"
        readOnly
      />
    ),
  };

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'MaterialProductId',
      text: formatMessage('material_product_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: false,
    },
    {
      dataField: 'MaterialKatashiki',
      text: formatMessage('material_katashiki'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'MaterialRequiredUnits',
      text: formatMessage('material_required_units'),
      sort: false,
      classes: 'show-Elipses',
      formatter: (cell: number) => cell.toFixed(2),
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'MaterialManufacturerName',
      text: formatMessage('material_manufacturer_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'SubContractorName',
      text: formatMessage('sub_contractor_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'AppearedInTrayId',
      text: formatMessage('appeared_in_tray_id'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
    },
  ];

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col"
            label="bom_search"
          />
          <div className="col-auto">
            <ul className="add-list">
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {getBOMSearchResultsServiceState.inProgress && (
            <FormLoader loading={getBOMSearchResultsServiceState.inProgress} />
          )}
          <Filter
            initialValues={filterObj}
            submitHandler={filterHandler}
            filterParmas={filterParams}
            isLoading={false}
            isFilterCleared={isFilterCleared}
            processOptions={allAssignedTasksNextProcessOptions}
            materialClassificationOptions={materialClassificationOptions}
          />
          {allProcessListData && allProcessListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices bom-table p-3 changingPanel pb-1">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allProcessListData && (
                      <Grid
                        data={allProcessListData}
                        columns={columns}
                        keyField="serialnumber"
                        loading={false}
                        rowClasses={rowClassFormat}
                        selectRow={selectRow}
                        // rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        // sort={{ ...columSortOrder }}
                        // remote={{ ...GridRemoteConstant }}
                        // onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allProcessListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="d-flex justify-content-end mb-2">
                    <Button
                      className="ms-3 btn-primary"
                      variant=""
                      type="button"
                      onClick={(event: any) => {
                        event.preventDefault();
                        const selectedGroups = getSelectedBOMGroups();

                        localStorage.setItem(
                          'selectedRows',
                          JSON.stringify(selectedGroups)
                        );
                        localStorage.setItem(
                          'filter',
                          JSON.stringify(filterObj)
                        );
                        history.push(RoutesConstants.MaterialTagAssign, {
                          state: filterObj,
                          bOMGroups: selectedGroups,
                        });
                      }}
                      disabled={
                        (filterObj.NextProcess !== '-3' &&
                          filterObj.NextProcess !== '-1') ||
                        selectedIds.length === 0
                      }
                    >
                      {formatMessage('assign_tag')}
                    </Button>
                    <Button
                      className="ms-3"
                      variant="secondary"
                      type="button"
                      onClick={(event: any) => {
                        event.preventDefault();
                        const selectedGroups = getSelectedBOMGroups();

                        localStorage.setItem(
                          'selectedRows',
                          JSON.stringify(selectedGroups)
                        );
                        localStorage.setItem(
                          'filter',
                          JSON.stringify(filterObj)
                        );
                        history.push(RoutesConstants.PartsSearch, {
                          state: filterObj,
                          bOMGroups: selectedGroups,
                        });
                      }}
                      disabled={selectedIds.length === 0}
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex align-items-center justify-content-sm-end">
                    <p className="me-3 mb-0">
                      {`${formatMessage('selectedItems')}: ${selectedRowsData.length}`}
                    </p>
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={
                        BOMSearchResultsList?.PagingDetails?.TotalRecords ?? 0
                      }
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message tagAssignMessageBom">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    {/* <FormattedMessage id="no_filters" /> */}
                    <FormattedMessage
                      id={isFilterCleared ? 'no_filters' : 'no_record'}
                    />
                  </h3>
                  <h4 className="mb-3">
                    {isFilterCleared
                      ? formatMessage('no_filter_message')
                      : formatMessage('')}
                  </h4>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow?.Messages}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            {/* <DimensionDetails selectedRowId={selectedRow.Id} /> */}
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(observer(BOMSearch));
